<div class="display-flex app-status-text mt-2">
    <div class="status-label-container">
        <i [class]="getApplicationIconClasses()"></i>
        <strong>{{ getAgencyApplicationStatusText() }}</strong>
    </div>

    <div *ngIf="canReview && assistanceApplication?.currentInformationRequest?.completedDate" class="info-request-container">
        <div class="current-info-request message-bubble">
            <div>Last updated by:</div>
            <div class="font-italic">{{assistanceApplication?.currentInformationRequest?.informationProvider || 'Unknown User'}}</div>
            <div class="font-italic">{{assistanceApplication.currentInformationRequest.completedDate | date: 'MM/dd/yyyy' }}</div>
        </div>
    </div>

    <button *ngIf="canReview && isUnitedWayAgencyUser && !isAgencyAssignedStep" class="btn btn-sm btn-success mt-2 mb-1" [tooltip]="'Application has passed review - set application status to \'Passed Review\''" placement="bottom" [delay]="1000" (click)="showPassReviewModal()">
        <i class="fa fa-check-circle me-1"></i>
        Pass UW Review</button>
    <button *ngIf="canReview && isUnitedWayAgencyUser && !isAgencyAssignedStep" class="btn btn-sm btn-primary mt-2 mb-1" [tooltip]="'Additional information or corrections are required - set application status back to \'Info Needed\''" placement="bottom" [delay]="1000" (click)="showInfoRequestModal()">
        <i class="fa fa-info-circle me-1"></i>
        UW Info Needed</button>
    <button *ngIf="canReview && ((!isAgencyAssignedStep && isUnitedWayAgencyUser) || (isAgencyAssignedStep))" class="btn btn-sm btn-danger mt-2 mb-1" [tooltip]="'Application is denied - set application status to \'Denied\''" placement="bottom" [delay]="1000" (click)="showDenyReviewModal()">
        <i class="fa fa-close me-1"></i>
        Deny</button>

    <button *ngIf="canReview && assistanceApplication?.status !== AssistanceApplicationStatus.UnderReview" class="btn btn-sm btn-info mt-2 mb-1" [tooltip]="'Application has passed Agency review - set application status to \'Under UW Review\''" placement="bottom" [delay]="1000" (click)="showPassAgencyReviewModal()">
        <i class="fa fa-check-circle me-1"></i>
        Pass Agency Review</button>
    <button *ngIf="canReview && ((!isAgencyAssignedStep && isUnitedWayAgencyUser) || isAgencyAssignedStep)" class="btn btn-sm btn-secondary mt-2 mb-1" [tooltip]="'Additional information or corrections are required from agency - set application status back to \'Agency Info Needed\''" placement="bottom" [delay]="1000" (click)="showAgencyInfoRequestModal()">
        <i class="fa fa-info-circle me-1"></i>
        Agency Info Needed</button>
    <div *ngIf="canSubmitReadyForReview" class="info-request-container">
        <div class="current-info-request message-bubble">
            <div class="font-italic">{{assistanceApplication?.currentInformationRequest?.requester || 'Unknown User'}}</div>
            <div class="font-italic">{{assistanceApplication.currentInformationRequest.requestDate | date: 'MM/dd/yyyy' }}</div>
            <div class="mt-2 note-text">
                {{assistanceApplication.currentInformationRequest.note}}
            </div>
        </div>
        <button *ngIf="!isAgencyAssignedStep && isUnitedWayAgencyUser" class="btn btn-sm btn-primary review-button mb-2" [tooltip]="'Update application status to \'Under Review\''" placement="bottom" [delay]="1000" (click)="setReadyForReview()">
            <i class="fa fa-send-o me-1"></i>
           Ready for UW Review</button>
        <button *ngIf="isAgencyAssignedStep" class="btn btn-sm btn-primary review-button mb-2" [tooltip]="'Update application status to \'Under Agency Review\''" placement="bottom" [delay]="1000" (click)="setReadyForReview()">
            <i class="fa fa-send-o me-1"></i>
            Ready for Agency Review</button>
    </div>
</div>
<prompt-dialog #agencyInfoRequestModal
               [size]="'lg'"
               [titleText]="'Application Agency Info Requested'"
               [showTitle]="true"
               [overrideFooter]="true">
    <div body>
        <app-info-requested-agency
                [assistanceApplicationId]="assistanceApplicationId"
                (closeModal)="onClickCancelAgencyInfoRequest()"
        ></app-info-requested-agency>
    </div>

    <div footer></div>
</prompt-dialog>

<prompt-dialog #passAgencyReviewModal
               [size]="'lg'"
               [titleText]="'Pass Agency Application Review'"
               [showTitle]="true"
               [overrideFooter]="true">
    <div body>
        <app-pass-review-agency
                [assistanceApplicationId]="assistanceApplicationId"
                [requireAdditionalInfo]="false"
                (closeModal)="onClickCancelPassAgencyReview()"
        ></app-pass-review-agency>
    </div>

    <div footer></div>
</prompt-dialog>

<prompt-dialog #passReviewModal
               [size]="'lg'"
               [titleText]="'Pass Application Review'"
               [showTitle]="true"
               [overrideFooter]="true">
    <div body>
        <app-pass-review
                [assistanceApplicationId]="assistanceApplicationId"
                [requireAdditionalInfo]="false"
                (closeModal)="onClickCancelPassReview()"
        ></app-pass-review>
    </div>

    <div footer></div>
</prompt-dialog>

<prompt-dialog #denyReviewModal
               [size]="'lg'"
               [titleText]="'Deny Application'"
               [showTitle]="true"
               [overrideFooter]="true">
    <div body>
        <app-deny-review
                [assistanceApplicationId]="assistanceApplicationId"
                (closeModal)="onClickCancelDenyReview()"
        ></app-deny-review>
    </div>

    <div footer></div>
</prompt-dialog>


<prompt-dialog #infoRequestModal
               [size]="'lg'"
               [titleText]="'Application Info Requested'"
               [showTitle]="true"
               [overrideFooter]="true">
    <div body>
        <app-info-requested
                [assistanceApplicationId]="assistanceApplicationId"
                (closeModal)="onClickCancelInfoRequest()"
        ></app-info-requested>
    </div>

    <div footer></div>
</prompt-dialog>

